window.addEventListener('load', (event) => {

	var rowLinks = document.querySelectorAll('.table-row-link');

	rowLinks.forEach(function(x){
		var dataHref = x.getAttribute("data-href");

		x.addEventListener("click", () => {
			window.location.href = dataHref;
		});	
	});

});